<!--
作者：Loong
时间：2020/11/10
-->
<!-- InvoiceApply [ 申请发票 ] -->
<template>

    <div id='invoiceApply' class="invoice">
        <div class="invoice_header">
			<h3>发票申请</h3>
			<span @click="AddAccount" v-if="addAccent">？未绑定服务费发票信息，请点击这里</span>
			<span @click="showAddAccount" v-if="showAddAccent">服务费发票信息</span>
		</div>
		<div class="invoice_content">
			<h3>服务费发票按自然月开具，发票开具金额为每月1号~月底充值款已结算部分服务费之和。当月服务费发票只能次月申请。</h3>
			<div class="invoice_list">
				 <ul>
					<li>
						<div class="msgList_title">
							<span class="invoice_allCheck" style="background-color: #666 !important;color: white;">
								<div class="invoice_checkBox" :class="{invoice_checkBox_true :checkAllBox == true}" @click='checkAll'></div>
							</span>
							<span class="invoice_msg_content" style="background-color: #666 !important;color: white;text-align: center;height:40px;line-height:40px">收入月份</span>
							<span class="invoice_msg_time" style="background-color: #666 !important;color: white;">开票金额（元）</span>
						</div>
					</li>
					<li v-for="(item,index) in invoiceList">
						<div class="msgList_title">
							<span class="invoice_allCheck" >
								<div class="invoice_checkBox"  :class="{'invoice_checkBox_true':item.status == 1}" @click="handleSelectionChange(item,index)"></div>
							</span>
							<span class="invoice_msg_content" :style="{'color':item.color,'background-image':item.mailBg}">{{item.time}}</span>
							<span class="invoice_msg_time">{{item.total}}</span>
						</div>
					</li>
				</ul>
				<div class="noInvoiceList" v-if="invoiceList == ''">
					暂无可开票数据
				</div>
			</div>
			 	<el-radio v-model="invoiceType" label="1">增值税普通发票</el-radio>
  				<el-radio v-model="invoiceType" label="2">增值税专用发票</el-radio>
  				<el-button  type="primary" style="display: block;margin: 0 auto;margin-top: 30px;width: 150px;" @click="sumbitInvoice()">申请</el-button>
		</div>
		<div class="invoice_add_bg" v-if='showInvoiceBg'>
			<!--未绑定-->
			<div class="invoice_add_account" v-if="showInvoiceAcc">
				<h3>发票信息</h3>
				<div class="add_account_service">
					<div class="add_service_left">
						<span>发票信息</span>
					</div>
					<div class="add_service_right">
						<ul>
							<li>
								<span><rt style="color: red;">*</rt>单位名称：</span>
								<strong><el-input v-model="lift_company" placeholder="请输入单位名称"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>税号：</span>
								<strong><el-input v-model="lift_duty_nub" placeholder="请输入税号"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>地址：</span>
								<strong><el-input v-model="lift_address" placeholder="请输入地址"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>电话：</span>
								<strong><el-input v-model="lift_phone" placeholder="请输入电话"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>开户行名称：</span>
								<strong><el-input v-model="lift_bank" placeholder="请输入开户行名称"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>账户：</span>
								<strong><el-input v-model="lift_account" placeholder="请输入账户"></el-input></strong>
							</li>
						</ul>
					</div>
				</div>
				<div class="add_account_from">
					<div class="add_from_left">
						<span>寄送信息</span>
					</div>
					<div class="add_from_right">
						<ul>
							<li>
								<span><rt style="color: red;">*</rt>收件人姓名：</span>
								<strong><el-input v-model="recipient" placeholder="请输入收件人姓名"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>收件人联系电话：</span>
								<strong><el-input v-model="recipient_phone" placeholder="请输入收件人联系电话"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>收件人地址：</span>
								<strong><el-input v-model="recipient_address" placeholder="请输入收件人地址"></el-input></strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>邮编：</span>
								<strong><el-input v-model="zip_code" placeholder="请输入邮编"></el-input></strong>
							</li>
						</ul>
					</div>
				</div>
				<div class="add_rt_msg">
					<p>注：请确保填写账户信息完整正确，确保与我公司签订的合同信息保持一致。因账户信息错误导致汇款经济纠纷以及法律责任均与我公司无关，一切责任由贵公司负责</p>
					<el-button type="primary" @click="sumbitAddAcc">保存</el-button>
					<el-button type="primary" @click="closeAddAcc">关闭</el-button>
				</div>
			</div>
			<!--已绑定-->
			<div class="invoice_add_account" v-if="showInvoiceMsg">
				<h3>发票信息</h3>
				<div class="add_account_service">
					<div class="add_service_left">
						<span>发票信息</span>
					</div>
					<div class="add_service_right">
						<ul>
							<li>
								<span><rt style="color: red;">*</rt>单位名称：</span>
								<strong>{{lift_company}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>税号：</span>
								<strong>{{lift_duty_nub}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>地址：</span>
								<strong>{{lift_address}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>电话：</span>
								<strong>{{lift_phone}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>开户行名称：</span>
								<strong>{{lift_bank}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>账户：</span>
								<strong>{{lift_account}}</strong>
							</li>
						</ul>
					</div>
				</div>
				<div class="add_account_from">
					<div class="add_from_left">
						<span>寄送信息</span>
					</div>
					<div class="add_from_right">
						<ul>
							<li>
								<span><rt style="color: red;">*</rt>收件人姓名：</span>
								<strong>{{recipient}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>收件人联系电话：</span>
								<strong>{{recipient_phone}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>收件人地址：</span>
								<strong>{{recipient_address}}</strong>
							</li>
							<li>
								<span><rt style="color: red;">*</rt>邮编：</span>
								<strong>{{zip_code}}</strong>
							</li>
						</ul>
					</div>
				</div>
				<div class="add_rt_msg">
					<p>注：请确保填写账户信息完整正确，确保与我公司签订的合同信息保持一致。因账户信息错误导致汇款经济纠纷以及法律责任均与我公司无关，一切责任由贵公司负责</p>
					<el-button type="primary" @click="closeShowAddAcc" style="margin-top: 65px;width: 100px;">关闭</el-button>
				</div>
			</div>
			<!--end-->
			<div class="sureSumbit" v-if="showSumbitList">
				<ul>
					<li>
						单位名称：{{lift_company}}
					</li>
					<li>
						税号：{{lift_duty_nub}}
					</li>
					<li>
						开票月份：<span v-for="item in invoiceTime">{{item}}，</span>
					</li>
					<li>
						开票金额：{{invoiceMoney}}（元）
					</li>
					<li>
						发票类型：{{invoiceTypeName}}
					</li>
					
				</ul>
					<el-button type="primary" style="width: 100px;margin-top: 20px;" @click="upDateSumbitList">提交</el-button>
					<el-button type="primary" style="width: 100px;margin-bottom: 20px;" @click="closeSumbitList">取消</el-button>
			</div>
		</div>
    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            addAccent:false,
            showAddAccent:false,
            showInvoiceBg:false,
            showInvoiceAcc:false,
            showInvoiceMsg:true,
            showSumbitList:false,
            /*添加账号*/
            lift_company:'',
            lift_duty_nub:'',
            lift_address:'',
            lift_phone:'',
            lift_bank:'',
            lift_account:'',
            recipient:'',
            recipient_phone:'',
            recipient_address:'',
            zip_code:'',
            /*勾选列表*/
            invoiceList:[],
            sumbitList:[],
            invoiceType:'1',
            invoiceTypeName:'',
            invoiceMoney:'',
            invoiceTime:[],
            checkAllBox:false,
            invoiceNum:[],
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.searchInvoiceList()
    },

    methods:{
        checkAll(){
            this.checkAllBox =!this.checkAllBox
            for(var i=0;i<this.invoiceList.length;i++){
                if(this.checkAllBox == true){
                    this.invoiceList[i].status = 1
                }else{
                    this.invoiceList[i].status = 0
                }
            }
        },
        changeBgImage(item,index){
            console.log(item)
            
        },
        /*申请方法*/
        searchInvoiceList(){
            this.$jssdk.property_treceipt.info({},(res)=>{
                this.invoiceList = res.list
                if(res.lift_company != ''){
                    this.addAccent = false
                    this.showAddAccent = true
                }else{
                    this.addAccent = true
                    this.showAddAccent = false
                }
                this.lift_company = res.lift_company
                this.lift_duty_nub = res.lift_duty_nub
                this.lift_address = res.lift_address
                this.lift_phone = res.lift_phone
                this.lift_bank =res.lift_bank
                this.lift_account = res.lift_account
                this.recipient = res.recipient
                this.recipient_phone = res.recipient_phone
                this.recipient_address =res.recipient_address
                this.zip_code = res.zip_code
            },(err)=>{
                this.$message({
                    type:'warning',
                    duration:1000,
                    message:err.msg
                })
            })
        },
        handleSelectionChange(item,index){
            this.invoiceNum.push(index)
            if(item.status === 0){
                    item.status = 1
            }else{
                item.status = 0
            }
            if(item.status != 1){
                this.checkAllBox = false
            }
        },
        sumbitInvoice(){
            var a = ''
            var d = this.invoiceNum.sort()
                console.log(d)
                for(var i=0;i<d.length;i++){
                    if(i+1 != d.length){
                        if(d[i]+1 == d[i+1]){
                            console.log(d[i]+1,d[i+1])
                        }else{
                            this.$message({
                                type:'warning',
                                duration:1000,
                                message:'请选择连续的月份'
                            })
                            for(var k=0;k<this.invoiceList.length;k++){
                                this.invoiceList[k].status = 0
                                this.invoiceNum = []
                            }
                            return 
                        }
                    }else{
                        console.log('aaa错误')
                    }
                }
                if(this.addAccent == true){
                    return this.$message({
                        type:'warning',
                        message:'请完善服务费发票信息',
                        duration:2000
                    })
                }
                if(this.invoiceList == ''){
                    return this.$message({
                        type:'warning',
                        message:'暂无数据无法提交申请',
                        duration:2000
                    })
                }
                var timeList = new Array()
                var moneyList = new Array()
                var sumbitId = new Array()
                var allMoney = 0
                for(var i=0;i<this.invoiceList.length;i++){
                    if(this.invoiceList[i].status == 1){
                        timeList.push(this.invoiceList[i].time)
                        moneyList.push(this.invoiceList[i].total)
                        sumbitId.push(this.invoiceList[i].id)
                    }
                }
                for(var k=0;k<moneyList.length;k++){
                    allMoney = allMoney+ Number(moneyList[k])
                }
                var a = 0
                var b  = allMoney + ''
                a = b.substring(0,b.indexOf(".") + 3)
                console.log(a+'chengchu')
                this.invoiceMoney = a
                this.invoiceTime = timeList
                this.sumbitList = sumbitId
                if(this.invoiceTime == ''){
                    return this.$message({
                        type:'warning',
                        message:'请勾选月份',
                        duration:2000
                    })
                }
                this.showInvoiceBg = true
                this.showInvoiceAcc = false
                this.showInvoiceMsg = false
                this.showSumbitList = true
                if(this.invoiceType == '1'){
                    this.invoiceTypeName = '增值税普通发票'
                }else{
                    this.invoiceTypeName = '增值税专用发票'
                }
            
            
        },
        upDateSumbitList(){
            this.$jssdk.property_treceipt.create(
                {type:this.invoiceType,ids:this.sumbitList,money:this.invoiceMoney},(res)=>{
                    console.log(res)
                    this.$message({
                        type:'success',
                        duartion:1000,
                        message:res
                    })
                    this.showInvoiceBg =false
                    this.showInvoiceAcc = false
                    this.showInvoiceMsg = false
                    this.showSumbitList = false
                    return this.searchInvoiceList()
                },(err) =>{
                    this.$message({
                        type:'warning',
                        duration:1000,
                        message:err.msg
                    })
                }
            )},
        /*添加账号*/
        AddAccount(){
            this.showInvoiceBg = true
            this.showInvoiceAcc = true
            this.showInvoiceMsg = false
            this.showSumbitList = false
        },
        showAddAccount(){
            this.showInvoiceBg = true
            this.showInvoiceAcc = false
            this.showInvoiceMsg = true
            this.showSumbitList = false
        },
        sumbitAddAcc(){
            if(this.lift_company == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写单位名称',
                })
            }
            if(this.lift_duty_nub == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写税号',
                })
            }
            if(this.lift_address == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写地址',
                })
            }
            if(this.lift_phone == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写电话',
                })
            }
            if(this.lift_bank == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写开户行名称',
                })
            }
            if(this.lift_account == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写账户',
                })
            }
            if(this.recipient == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写收件人姓名',
                })
            }
            if(this.recipient_phone == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写收件人电话',
                })
            }
            if(this.recipient_address == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写收件人地址',
                })
            }
            if(this.zip_code == ''){
                return this.$message({
                    type:'warning',
                    duration:1000,
                    message:'请填写邮编',
                })
            }
            this.$jssdk.property_treceipt.addAccount({
                lift_company:this.lift_company,
                lift_duty_nub:this.lift_duty_nub,
                lift_address:this.lift_address,
                lift_phone:this.lift_phone,
                lift_bank:this.lift_bank,
                lift_account:this.lift_account,
                recipient:this.recipient,
                recipient_phone:this.recipient_phone,
                recipient_address:this.recipient_address,
                zip_code:this.zip_code
            },(res) =>{
                this.showInvoiceBg =false
                this.showInvoiceAcc = false
                this.showInvoiceMsg = false
                this.showSumbitList = false
                this.$message({
                    type:'success',
                    duration:1000,
                    message:'保存成功'
                })
                return this.searchInvoiceList()
            },(err) =>{
                this.$message({
                    type:'warning',
                    duration:1000,
                    message:err.msg
                })
            })
            
        },
        closeAddAcc(){
            this.showInvoiceBg =false
            this.showInvoiceAcc = false
            this.showInvoiceMsg = false
            this.showSumbitList = false
        },
        closeShowAddAcc(){
            this.showInvoiceBg =false
            this.showInvoiceAcc = false
            this.showInvoiceMsg = false
            this.showSumbitList = false
        },
        closeSumbitList(){
            this.showInvoiceBg =false
            this.showInvoiceAcc = false
            this.showInvoiceMsg = false
            this.showSumbitList = false
            for(var k=0;k<this.invoiceList.length;k++){
                this.invoiceList[k].status = 0
                this.invoiceNum = []
            }
        }
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
    .noInvoiceList{
		height: 400px;
		line-height: 400px;
		border: 1px solid black;
		width: 371px;
	}
    .invoice_list ul{
        list-style: none;
        padding: 0;
        margin: 0;
        width: 371px;
        border-right: 1px solid black;
        border-left: 1px solid black;
    }
    .invoice_list ul li{
        overflow: hidden;
        border-bottom: 1px solid black;
        font-size: 12px;
    }
    .invoice_list ul li:first-child{
        border-top: 1px solid black;
    }
    .invoice_list ul li span{
        margin: 0;
        padding: 0;
    }
    .invoice_checkBox{
        background-repeat: no-repeat;
        background-size: 100%;
        width: 15px;
        height: 15px;
        float: left;
        margin-top: 12px;
        margin-left: 20px;
        background-image: url(../../assets/check.png)
    }
    .invoice_checkBox_true{
        background-image:url(../../assets/check_true.png) !important
    }
    .invoice_allCheck{
        width: 60px;
        display: inline-block;
        float: left;
        color: black;
        background-color: #fff;
        height: 40px;
        line-height: 40px;
        border-right: 1px solid black;
        text-align: center;
    }
    .invoice_msg_content{
        display: inline-block;
        float: left;
        color: black;
        background-color: #fff;
        width:160px;
        text-align: center;
        background-repeat: no-repeat;
        background-position: 5px;
        height: 40px;
        line-height: 40px;
        background-size: 15px;
    }
    .invoice_msg_time{
        display: inline-block;
        float: left;
        color: black;
        background-color: #fff;
        width:149px;
        height: 40px;
        line-height: 40px;
        border-left: 1px solid black;
        text-align: center;
    }
        /*提交服务费发票申请*/
    .sureSumbit{
        background-color: white;
        width: 680px;
        margin: 0 auto;
        text-align: center;
        margin-top: 11%;
        border-radius: 10px;
    }
    .sureSumbit ul{
        list-style: none;
        padding: 0;
        margin: 0;
        overflow: auto;
    }
    .sureSumbit ul li {
        line-height: 40px;
        border-bottom: 1px solid #ccc;
        border-top: none;
        padding: 15px;
        font-size: 14px;
        text-align: left;
    }
    .invoice_list{
        width: 425px;
        margin: 0 auto;
        height: 560px;
        overflow: auto;
        margin-bottom: 20px;
        
    }
        /*添加账号信息*/
    .add_rt_msg{
        text-align: center;
        margin-bottom: 20px;
    }
    .add_rt_msg p{
        color: red;
        width: 400px;
        margin: 0 auto;
        margin-top: 40px;
        margin-bottom: 40px;
        font-size: 14px;
        text-align: left;
    }
    .add_from_right{
        float: left;
        border:1px solid black;
        width: 590px;
        border-top: none;
    }	
    .add_from_left{
        float: left;
        width: 200px;
        text-align: center;
        border: 1px solid black;
        border-top: none;
        border-right:none;
    }
    .add_from_left span{
        width: 200px;
        height: 171px;
        line-height: 171px;
        display: block;
        
    }
    .add_from_right ul{
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .add_from_right ul li{
        height: 42px;
        border-bottom: 1px solid black;
        overflow: hidden;
        line-height: 42px;
        font-size: 14px;
    }
    .add_from_right ul li:last-child{
        border: none;
    }
    .add_from_right ul li span{
        border-right:1px solid black;
        width: 150px;
        height: 42px;
        line-height: 42px;
        display: inline-block;
        float: left;
        text-align: right;
    }
    .add_from_right ul li strong{
        display: inline-block;
        float: left;
        margin-left: 20px;
        font-weight: normal;
    }
    .add_account_from{
        overflow: hidden;
    }
    .add_service_right{
        float: left;
        border:1px solid black;
        width: 590px;
    }	
    .add_service_right ul{
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .add_service_right ul li{
        height: 42px;
        border-bottom: 1px solid black;
        overflow: hidden;
        line-height: 42px;
        font-size: 14px;
    }
    .add_service_right ul li:last-child{
        border: none;
    }
    .add_service_right ul li span{
        border-right:1px solid black;
        width: 150px;
        height: 42px;
        line-height: 42px;
        display: inline-block;
        float: left;
        text-align: right;
    }
    .add_service_right ul li strong{
        display: inline-block;
        float: left;
        
        margin-left: 20px;
        font-weight: normal;
    }
    .add_service_left{
        float: left;
        width: 200px;
        text-align: center;
        border: 1px solid black;
        border-right:none;
    }
    .add_service_left span{
        width: 200px;
        height: 257px;
        line-height: 257px;
        display: block;
        
    }
    .add_account_service{
        overflow: hidden;
    }

    .invoice_add_account{
        width: 800px;
        margin: 0 auto;
        margin-top: 30px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
    }
    .invoice_add_account h3{
        text-align: center;
        font-weight: normal;
        font-size: 16px;
    }
    .invoice_add_bg{
        background-color: rgba(0,0,0,.7);
        width:100%;
        height: 100%;
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
    }
    .invoice_header{
        border-bottom:1px solid #000;
        overflow: hidden;
    }
    .invoice_header h3{
        font-weight: normal;
        font-size: 16px;
        float: left;
    }
    .invoice_header span{
        float:right;
        color: red;
        font-size: 14px;
        display: inline-block;
        margin: 16px 20px 16px 0;
        cursor: pointer;
    }
    .invoice_content{
        text-align: center;
    }
    .invoice_content h3{
        font-weight: normal;
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// InvoiceApply.vue?26a2a82c